export default __webpack_public_path__ + "static/media/Taste of Ionnyk.88d16b6c.jpeg";